import { Badge, Theme, styled } from "@mui/material";

interface StyledBadgeProps {
    theme?: Theme;
    custombackgroundcolor: string;
    customcolor: string;
}

export const StyledBadge = styled(Badge)(({ theme, custombackgroundcolor, customcolor }: StyledBadgeProps) => ({
    '& .MuiBadge-badge': {
        backgroundColor: custombackgroundcolor,
        color: customcolor,
        boxShadow: `0 0 0 2px ${theme?.palette.background.paper}`,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            animation: 'ripple 2s infinite ease-in-out',
            border: '1px solid currentColor',
            content: '""',
        },
    },
    '@keyframes ripple': {
        '0%': {
            transform: 'scale(.8)',
            opacity: 1,
        },
        '100%': {
            transform: 'scale(2.4)',
            opacity: 0,
        },
    },
}));